import {useMemo} from 'react';

/**
 *
 *  While searching, we also want to display sections with names that match the search
 */
export const useSectionNameMatch = (
  sectionName: string,
  searchRegex: RegExp | null
) => {
  return useMemo(() => {
    if (searchRegex == null) {
      return false;
    }

    if (searchRegex.source.includes('?!')) {
      return false;
    }

    return searchRegex.test(sectionName);
  }, [searchRegex, sectionName]);
};
